import React, { useState } from "react"
import { Container, Form} from "reactstrap"
import { useFormik } from "formik"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../components/ResultHandler"
import FormButtonHandler from "../../../components/FormButtonHandler"
import { useResponse } from "../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../hooks/useGetInstence"
import { CAR_REQUIRED_FIELDS } from "./CONSTANT"
import * as Yup from "yup"
import CarForm from "./CarForm"
import { editCar, getCar } from "../../../api/cars"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

CAR_REQUIRED_FIELDS.forEach((f) => {
    initialValues[f.key] = TYPES[f.type] || "";
    
    if (f.type == "file") {
        FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
            "This Field Is Required"
        );
    } else if (f.type == "select" && f.isMulti) {
        FIELDS_VALIDATION[f.key] = Yup.array();
    } else {
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
    }
});

const EditCar = () => {
    let navigate = useHistory()
    const { t } = useTranslation()
    const {id: carId} = useParams()
    const [editedCar, setEditedCar] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getCar,
        carId,
        response => {
            setEditedCar({
                ...response.data.car,
                picture_preview: response.data.car.picture,
                picture: null,
            })
        }
    )

    const { setData, loading, error, success } = useResponse(editCar, () => {
        navigate.goBack()
    })
    
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {...editedCar},
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: (values) => {
            let data = new FormData()

            Object.keys(values).map(key => {
                if(values[key]){
                    data.append(key, values[key])
                }
            })

            setData({ type: "edit", id: carId, data })
        },
    })

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Cars")}
                        breadcrumbItem={t("btns.Edit") + " " + t("Car")}
                    />
                    
                        {editedCar && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <CarForm validation={validation} />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>
                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditCar